import { render, staticRenderFns } from "./offenders.vue?vue&type=template&id=5ab7cc48&scoped=true"
import script from "./offenders.vue?vue&type=script&lang=js"
export * from "./offenders.vue?vue&type=script&lang=js"
import style0 from "./offenders.vue?vue&type=style&index=0&id=5ab7cc48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab7cc48",
  null
  
)

export default component.exports